import { ComentarioApi as Api } from "./comentario.api";

export class ComentarioPendingFacade {
  static approve(item) {
    return Api.approveByComercioIdAndUsuarioId(item.idComercio, item.idUsuario);
  }

  static countWithFilter(filter) {
    return Api.countPendingWithFilter(filter);
  }

  static async getListWithFilter(filter) {
    const list = (await Api.getPendingListWithFilter(filter)).data;

    return { data: list.map(dto => this._toModel(dto)) };
  }

  static reject(item) {
    return Api.rejectByComercioIdAndUsuarioId(item.idComercio, item.idUsuario);
  }

  /** Devuelve un título calculado según las estrellas */
  static _calcularTitulo(comentario) {
    switch (comentario.estrellas) {
      case 1:
        return "Muy malo";
      case 2:
        return "Malo";
      case 3:
        return "Bueno";
      case 4:
        return "Muy bueno";
      case 5:
        return "Excelente";
      default:
        return "";
    }
  }

  static _toModel(dto) {
    // Crear un id único basado en los ids compuestos, sirve para que
    // componentes que trabajan con id puedan trabajar normalmente
    dto.id = "c" + dto.idComercio + "u" + dto.idUsuario;
    if (!dto.titulo) {
      dto.titulo = this._calcularTitulo(dto);
    }
    return dto;
  }
}
